// import { RxCrossCircled } from "react-icons/rx";
// import { CiCircleCheck } from "react-icons/ci";
// import { useParams } from "react-router-dom";
// import { useEffect } from "react";
// import axios from "config/axios";

// function VerifyEmailScreen() {
//   const token = localStorage.getItem("token");
//   const { email } = useParams();
//   console.log(email, "email");
//   const origin = window.location.origin;
//   console.log("window origin", origin);

//   useEffect(async () => {
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`,
//         { email, origin }
//       );
//       console.log("respone", response);
//     } catch (error) {
//       console.log("error", error);
//     }
//   }, []);

//   return (
//     <div className="flex flex-col items-center justify-center mt-20 gap-5">
     
//       <div className="flex flex-col items-center gap-2 max-w-[450px]">
//         <CiCircleCheck className="h-8 w-8 text-green-500" />

//         <p className="text-muted-foreground ">
//           Thank you for joining. A message has been sent to
//           <span className="text-blue-500"> {email}. </span>
//           Please confirm your email to be able to Sign In.
//         </p>
//         <p className="text-red-500 font-bold">If you haven't received the email, please check your spam or junk folder.</p>
//       </div>
//       {/* //   )} */}
//     </div>
//   );
// }

// export default VerifyEmailScreen;


import { RxCrossCircled } from "react-icons/rx";
import { CiCircleCheck } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import axios from "config/axios";

function VerifyEmailScreen() {
  const token = localStorage.getItem("token");
  const { email } = useParams();
  const origin = window.location.origin;

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`,
          { email, origin }
        );
        console.log("response", response);
      } catch (error) {
        console.log("error", error);
      }
    };

    verify();
  }, [email, origin]);

  return (
    <div className="flex items-center justify-center min-h-screen px-4">
      <div className="flex flex-col items-center gap-4 w-full max-w-md text-center">
        <CiCircleCheck className="h-12 w-12 text-green-500" />

        <p className="text-muted-foreground">
          Thank you for joining. A message has been sent to
          <span className="text-blue-500"> {email}. </span>
          Please confirm your email to be able to Sign In.
        </p>

        <p className="text-red-500 font-bold">
          If you haven't received the email, please check your spam or junk folder.
        </p>
      </div>
    </div>
  );
}

export default VerifyEmailScreen;

